import { Utils } from "utils";
import { IPlace, ITag, Iterable } from "types";

export const filterPlaces = (places: Iterable<IPlace>[]) => {
  return places.filter((item) => {
    /* Filter by 'rating' & 'votes' */
    const isRatingAllowed = item.rating.value >= 4;
    const isVotesAllowed = item.rating.votes_count >= 100;

    /* Filter by availability for building in route */
    const isRouteAvailable = Utils.Places.isAvailableForRouting(item) === "YES";

    /* Filter by time availability (timetable param exists) */
    /* If passTimetableCheck == true => do not check timetable  */
    let hasTimetable = item.work_hours.timetable !== null;
    if (Utils.Places.passTimetableCheck(item)) hasTimetable = true;

    return (
      isRatingAllowed && isVotesAllowed && isRouteAvailable && hasTimetable
    );
  });
};

export const setBreaktimes = (places: Iterable<IPlace>[], tags: ITag[]) => {
  return places.map((item) => Utils.Places.setBreaktime(item, tags));
};
